import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Table, Pagination, Popconfirm, Button, Tag, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { withRouter } from "react-router";
import moment from "moment";
import AddMineralModal from "../../../TakeIn/addMineralModal";
import logo from "../../../../Images/Logo 2.png";
import {
    getMineralSamples,
    updateMineralSampleEntry,
    deleteMineralSampleEntry,
} from "../../../../modules/actions/mineralActions";

const { Column } = Table;

function MineralReceipt(props) {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editData, setEditData] = useState(null);

    const fetchData = (pg = page, ps = pageSize) => {
        props.getMineralSamples(
            {
                page: pg,
                page_size: ps,
                startDate: props.startDate
                    ? moment(props.startDate).format("YYYY-MM-DD")
                    : undefined,
                endDate: props.endDate
                    ? moment(props.endDate).format("YYYY-MM-DD")
                    : undefined,
                searchText: props.keyword || undefined,
            },
            props.selectedBranch
        );
    };

    useEffect(() => {
        fetchData(1, pageSize);
        setPage(1);
    }, [props.searchBool, props.selectedBranch]);

    const handleEdit = (record) => {
        setEditData(record);
        setEditModalVisible(true);
    };

    const handleUpdate = (entryNo, payload) => {
        props.updateMineralSampleEntry(entryNo, { mineralSampleData: payload }, () => {
            setEditModalVisible(false);
            setEditData(null);
            fetchData();
        });
    };

    const handleUpdateAndContinue = (entryNo, payload) => {
        props.updateMineralSampleEntry(entryNo, { mineralSampleData: payload }, () => {
            setEditModalVisible(false);
            setEditData(null);
            props.history.push(`/mineral-testing-form/${entryNo}`);
        });
    };

    const handleDelete = (entryNo) => {
        props.deleteMineralSampleEntry(entryNo, () => {
            fetchData();
        });
    };

    const handlePageChange = (pg, ps) => {
        setPage(pg);
        setPageSize(ps);
        fetchData(pg, ps);
    };

    const samples = props.mineralSamples || [];
    const total = props.mineralSamplesTotal || 0;

    return (
        <div className="recieptReports">
            <div className="tableDiv">
                {props.mineralReportLoading ? (
                    <div className="loaderDiv tableLoader">
                        <div>
                            <img src={logo} />
                        </div>
                    </div>
                ) : null}
            <Table
                dataSource={samples}
                rowKey="entryNo"
                pagination={false}
                className="itemsTable"
                scroll={{ x: true }}
            >
                <Column title="Entry No" dataIndex="entryNo" key="entryNo" />
                <Column
                    title="Date"
                    dataIndex="entryDate"
                    key="entryDate"
                    render={(val) => (val ? moment(val).format("DD-MM-YYYY") : "-")}
                />
                <Column title="Branch" dataIndex="branchCode" key="branchCode" />
                <Column title="Customer" dataIndex="customerName" key="customerName" />
                <Column title="Sample Type" dataIndex="sampleType" key="sampleType" />
                <Column
                    title="Requested Analysis"
                    dataIndex="requestedAnalysis"
                    key="requestedAnalysis"
                    render={(arr) =>
                        Array.isArray(arr)
                            ? arr.map((a) => (
                                  <Tag key={a} color="blue" style={{ marginBottom: 2 }}>
                                      {a}
                                  </Tag>
                              ))
                            : "-"
                    }
                />
                <Column
                    title="Amount"
                    dataIndex="totalAmount"
                    key="totalAmount"
                    render={(val) => (val !== undefined ? `PKR ${val}` : "-")}
                />
                <Column
                    title="Report Status"
                    key="reportStatus"
                    render={(_, record) =>
                        record.mineralReport ? (
                            <Tag color="green">{record.mineralReport.status || "Generated"}</Tag>
                        ) : (
                            <Tag color="orange">Pending</Tag>
                        )
                    }
                />
                <Column
                    title="Actions"
                    key="actions"
                    render={(_, record) => (
                        <div style={{ display: "flex", gap: 8 }}>
                            <Tooltip title="Edit">
                                <Button
                                    icon={<EditOutlined />}
                                    size="small"
                                    onClick={() => handleEdit(record)}
                                />
                            </Tooltip>
                            <Popconfirm
                                title="Delete this mineral sample?"
                                onConfirm={() => handleDelete(record.entryNo)}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Tooltip title="Delete">
                                    <Button
                                        icon={<DeleteOutlined />}
                                        size="small"
                                        danger
                                    />
                                </Tooltip>
                            </Popconfirm>
                        </div>
                    )}
                />
            </Table>
            </div>

            <Pagination
                current={page}
                pageSize={pageSize}
                total={total}
                showSizeChanger
                onChange={handlePageChange}
                onShowSizeChange={handlePageChange}
            />

            {editModalVisible && (
                <AddMineralModal
                    visible={editModalVisible}
                    editData={editData}
                    onUpdate={handleUpdate}
                    onUpdateAndContinue={handleUpdateAndContinue}
                    onClose={() => {
                        setEditModalVisible(false);
                        setEditData(null);
                    }}
                    onAddMineral={() => {}}
                />
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    mineralSamples: state.mineralStore.mineralSamples,
    mineralSamplesTotal: state.mineralStore.mineralSamplesTotal,
    mineralReportLoading: state.mineralStore.mineralReportLoading,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMineralSamples,
            updateMineralSampleEntry,
            deleteMineralSampleEntry,
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MineralReceipt));
